export { default, type IconDefinition, type IconRendererProps } from './IconRenderer';
